import { createColumnHelper } from "@tanstack/react-table"
import { ButtonEditCell } from "../../table/table-editable/ButtonEditCell"
import { TableCellEditable } from "../../table/table-editable/TableCellEditable"

export type TStudent = {
  id: number
  name: string
  dateOfBirth: string
  major: string
}

export const MOCK_DATA: TStudent[] = [
  {
    id: 1111,
    name: 'Bahar Constantia',
    dateOfBirth: '1984-01-04',
    major: 'Computer Science',
  },
  {
    id: 2222,
    name: 'Harold Nona',
    dateOfBirth: '1961-05-10',
    major: 'Communications',
  },
  {
    id: 3333,
    name: 'Raginolf Arnulf',
    dateOfBirth: '1991-10-12',
    major: 'Business',
  },
  {
    id: 4444,
    name: 'Marvyn Wendi',
    dateOfBirth: '1978-09-24',
    major: 'Psychology',
  },
]

// tạo column table dựa trên type
let columnHelper = createColumnHelper<TStudent>()
export const COLUMNS_EDITABLE = [
  columnHelper.accessor('id', {
    header: 'Student ID',
    cell: TableCellEditable,
    meta: {
      type: 'number'
    },
  }),
  columnHelper.accessor('name', {
    header: 'Full Name',
    cell: TableCellEditable,
    meta: {
      type: 'text'
    }
  }),
  columnHelper.accessor('dateOfBirth', {
    header: 'Date Of Birth',
    cell: TableCellEditable,
    meta: {
      type: 'date'
    }
  }),
  columnHelper.accessor('major', {
    header: 'Major',
    cell: TableCellEditable,
    meta: {
      type: 'select',
      options: [
        { value: 'Computer Science', label: 'Computer Science' },
        { value: 'Communications', label: 'Communications' },
        { value: 'Business', label: 'Business' },
        { value: 'Psychology', label: 'Psychology' },
      ]
    }
  }),
  // thêm cột feature
  columnHelper.display({
    header: 'Feature',
    id: 'edit',
    cell: ButtonEditCell
  })
]
export const COLUMNS_BASIC = [
  columnHelper.accessor('id', {
    header: 'Student ID',
    meta: {
      type: 'number'
    },
  }),
  columnHelper.accessor('name', {
    header: 'Full Name',
    meta: {
      type: 'text'
    }
  }),
  columnHelper.accessor('dateOfBirth', {
    header: 'Date Of Birth',
    meta: {
      type: 'date'
    }
  }),
  columnHelper.accessor('major', {
    header: 'Major',
    meta: {
      type: 'select',
      options: [
        { value: 'Computer Science', label: 'Computer Science' },
        { value: 'Communications', label: 'Communications' },
        { value: 'Business', label: 'Business' },
        { value: 'Psychology', label: 'Psychology' },
      ]
    }
  })
]

export const NEW_STUDENT: TStudent = {
  id: Math.floor(Math.random() * 10000),
  name: '',
  dateOfBirth: '',
  major: '',
}
